import { render, staticRenderFns } from "./orderSalsePriceSp.vue?vue&type=template&id=4a223ea0&scoped=true"
import script from "./orderSalsePriceSp.vue?vue&type=script&lang=js"
export * from "./orderSalsePriceSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a223ea0",
  null
  
)

export default component.exports